export const REQUEST_TRACKER_TRANSACTIONS = 'REQUEST_TRACKER_TRANSACTIONS';
export const RECEIVED_TRACKER_TRANSACTIONS_SUCCESS = 'RECEIVED_TRACKER_TRANSACTIONS_SUCCESS';
export const RECEIVED_TRACKER_TRANSACTIONS_ERROR = 'RECEIVED_TRACKER_TRANSACTIONS_ERROR';
